import { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

interface AiActionResponse {
  result: unknown;
}

export function useAiAction(householdId: string | null) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const callAction = async <T>(action: string, payload: Record<string, unknown>): Promise<T | null> => {
    if (!householdId) return null;
    setIsLoading(true);
    setError(null);
    try {
      const functions = getFunctions(getApp());
      const fn = httpsCallable<{ householdId: string; action: string; payload: Record<string, unknown> }, AiActionResponse>(functions, 'aiAction');
      const response = await fn({ householdId, action, payload });
      return response.data.result as T;
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : 'AI request failed';
      setError(msg);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { callAction, isLoading, error };
}
